import styled from "styled-components";

export const UserMenuSeparatorDefaultBox = styled.div`
    box-sizing: content-box;
    height: 1px;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    box-shadow: 0 0.35px 0 0 ${({theme}) => theme.colors.boxBorderContrast};
    margin-bottom: 1px;
`;